/**
 * 配置编译环境和线上环境之间的切换
 * 
 * host: 域名地址
 * urlPerfix: 接口地址
 * uploadAliyunOss: 是否上传到阿里云OSS
 * uploadFileFormat: 上传文件类型
 * 
 */

let host = 'http://localhost'
if (process.env.NODE_ENV == 'production') {
	host = 'https://tdata.tdrillenergy.com';
}

const urlPerfix = host + "/api/v1"
export {
	urlPerfix,
	host,
}